import template from './swag-cms-extensions-custom-form-element-select.html.twig';

export default {
    template,

    props: {
        field: {
            type: Object,
            required: true,
        },
    },
}
